import { COUNTRIES } from '@hotjar/country-lib';
import { useSettings } from './useSettings';

export function useCountries(): {
  COUNTRIES: typeof COUNTRIES;
  unsanctionedCountries: { label: string; value: string }[];
} {
  const { data: settings } = useSettings();

  const unsanctionedCountries = COUNTRIES.filter(
    ({ value }) =>
      !settings?.sanctioned_countries?.find(
        (sanctionedCountry) => sanctionedCountry.code === value,
      ),
  );

  return {
    COUNTRIES,
    unsanctionedCountries,
  };
}
